import { render, staticRenderFns } from "./LoadingWait.vue?vue&type=template&id=31fae589&scoped=true&"
import script from "./LoadingWait.vue?vue&type=script&lang=ts&"
export * from "./LoadingWait.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fae589",
  null
  
)

export default component.exports